module.exports = __webpack_public_path__ + "static/shield_on-e54d89969ac7363b84c6e3dc85cab643.png";